<template>
  <div class="layout-with-centered-max-width-child">
    <div>
      <div class="text">
        <div>
          <div class="paragraph">
            <span>TERMS OF SERVICE</span>
          </div>
          <div class="paragraph">
            <span>{{paragraphOne}}</span>
          </div>
        </div>
        <div>
          <div class="section">
            <span class="title-number">1.</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Our Services</span>
          </div>
          <div class="paragraph">
            <span class="title-number">1.1</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionOneParagraphOne}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">1.2</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionOneParagraphTwo}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">1.3</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionOneParagraphThree}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">1.4</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionOneParagraphFour}}</span>
          </div>
        </div>
        <div>
          <div class="section">
            <span class="title-number">2.</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Content – Submission, use and restrictions</span>
          </div>
          <div class="paragraph">
            <span class="title-number">2.1</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionTwoParagraphOne}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">2.2</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionTwoParagraphTwo}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">2.3</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionTwoParagraphThree}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">2.4</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionTwoParagraphFour}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">2.5</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionTwoParagraphFive}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">2.6</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionTwoParagraphSix}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">2.7</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionTwoParagraphSeven}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">2.8</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionTwoParagraphEight}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">2.9</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionTwoParagraphNine}}</span>
          </div>
        </div>
        <div>
          <div class="section">
            <span class="title-number">3.</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Intellectual Property</span>
          </div>
          <div class="paragraph">
            <span class="title-number">3.1</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionThreeParagraphOne}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">3.2</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionThreeParagraphTwo}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">3.3</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionThreeParagraphThree}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">3.4</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionThreeParagraphFour}}</span>
          </div>
        </div>
        <div>
          <div class="section">
            <span class="title-number">4.</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Information Collection</span>
          </div>
          <div class="paragraph">
            <span class="title-number">4.1</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionFourParagraphOne}}</span>
          </div>
        </div>
        <div>
          <div class="section">
            <span class="title-number">5.</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Personal Information</span>
          </div>
          <div class="paragraph">
            <span class="title-number">5.1</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionFiveParagraphOne}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">5.2</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionFiveParagraphTwo}}</span>
          </div>
        </div>
        <div>
          <div class="section">
            <span class="title-number">6.</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Use of Personal Information</span>
          </div>
          <div class="paragraph">
            <span class="title-number">6.1</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionSixParagraphOne}}</span>
          </div>
        </div>
        <div>
          <div class="section">
            <span class="title-number">7.</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Cookies</span>
          </div>
          <div class="paragraph">
            <span class="title-number">7.1</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionSevenParagraphOne}}</span>
          </div>
        </div>
        <div>
          <div class="section">
            <span class="title-number">8.</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Sharing</span>
          </div>
          <div class="paragraph">
            <span class="title-number">8.1</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionEightParagraphOne}}</span>
          </div>
        </div>
        <div>
          <div class="section">
            <span class="title-number">9.</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Security</span>
          </div>
          <div class="paragraph">
            <span class="title-number">9.1</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionNineParagraphOne}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">9.2</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionNineParagraphTwo}}</span>
          </div>
        </div>
        <div>
          <div class="section">
            <span class="title-number">10.</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Updates</span>
          </div>
          <div class="paragraph">
            <span class="title-number">10.1</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionTenParagraphOne}}</span>
          </div>
        </div>
        <div>
          <div class="section">
            <span class="title-number">11.</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Surveys</span>
          </div>
          <div class="paragraph">
            <span class="title-number">11.1</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionElevenParagraphOne}}</span>
          </div>
        </div>
        <div>
          <div class="section">
            <span class="title-number">12.</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Links</span>
          </div>
          <div class="paragraph">
            <span class="title-number">12.1</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionTwelveParagraphOne}}</span>
          </div>
        </div>
        <div>
          <div class="section">
            <span class="title-number">13.</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Contact Details</span>
          </div>
          <div class="paragraph">
            <span class="title-number">13.1</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionThirtheenParagraphOne}}</span>
          </div>
          <div class="paragraph">___________</div>
          <div class="paragraph">___________</div>
          <div class="paragraph">___________</div>
          <div class="paragraph">Ph. No. -</div>
          <div class="paragraph">Email -</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "Privacy",
      computed:{
        paragraphOne(){
          return `
              Welcome to BiMiLeap, a service provided by [*].
              BiMiLeap recognizes the importance of personal information
              submitted by its users and respects your privacy.
              Your use of our BiMiLeap, its website, mobile application,
              including the products, services and digital content offered
              by it (hereinafter “Content”) is governed by the following
              terms and conditions (hereinafter “Terms of Service”).
              BiMiLeap shall ensure that it takes reasonable steps
              to maintain the security, integrity and privacy of any
              information in accordance with the Terms of Service.
              By accepting these Terms of Service, you agree to
              the methods and extent of the collection,
              storage and use of your personal information with BiMiLeap.
          `
        },
        sectionOneParagraphOne(){
          return `
             BiMiLeap is a community development initiative that provides
             you with a knowledge creation and sharing platform with
             limitless possibilities, providing opportunities to think
             creatively, work collaboratively, learn experientially and
             to attract, train and recruit next generation of market researchers.
             Since our activities could be diverse, there may be additional
             terms or conditions that may be added, and this
             Terms of Service may be amended from time to time.
             Your continued use and availment of our Content shall
             imply your consent and agreement with such terms and
             conditions as may be modified or added from time
             to time to this Terms of Service.
          `
        },
        sectionOneParagraphTwo(){
          return `
            You understand and agree that the Content and BiMiLeap’s platform,
            its products and services, are provided to you on the
            basis as they exist and BiMiLeap shall not be held
            responsible in case of any failure to store or deliver
            content, information or other materials across networks.
          `
        },
        sectionOneParagraphThree(){
          return `
            Further, there may be Content offered by BiMiLeap or
            available or shared by our users on BiMiLeap which
            may contain age restricted material. You take full
            responsibility to ensure that you are of legal age
            to view, access or share such information and
            content in your jurisdiction.
          `
        },
        sectionOneParagraphFour(){
          return `
            Your use or our services and Content may require
             you to submit your personal information,
             including but not restricted to your name, gender,
             address, e-mail accounts and phone numbers. You agree
             that all such information that you provide shall be completely true.
             If any of such information is found to be incorrect,
             BiMiLeap reserves its right to terminate your account
             and stop all access to Content without any further notice to you.
          `
        },
        sectionTwoParagraphOne(){
          return `
          Except as provided in Clause 2.1,
          you agree and understand that you are granted a
          limited right to access the Content that is available
          on BiMiLeap and by virtue of such access, you do not own
          or have any proprietary rights to such Content,
          information and materials. Therefore, any use of
          such content, information or materials as is proprietary
          to BiMiLeap, cannot be used by you in any manner
          whatsoever, without our express written consent.
          `
        },
        sectionTwoParagraphTwo(){
          return `
          The content that you may submit to BiMiLeap,
          for instance such as while creating a new study,
          and expressly for being published, you represent
          that you own all rights, title and interests, whether
          in the nature of copyrights or other intellectual
          property rights in such content, and are authorized
          to publish the same and you hereby grant a worldwide
          non-exclusive license to BiMiLeap to share, publish,
          host or otherwise use such content, or allow it to be
          used in any manner whatsoever, without any further permission from you.
          `
        },
        sectionTwoParagraphThree(){
          return `
          You agree that that the information, materials
          and contents including case studies that are
          made accessible to you through the use of BiMiLeap,
          you shall make no reproduction of such content,
          information and materials, and that you shall not
          use, whether commercially or otherwise, by way of
          publication, broadcast, or such like manner, any
          part or whole of such content without the expression
          permission of BiMiLeap.
          `
        },
        sectionTwoParagraphFour(){
          return `
          You further represent that all information,
          literary content, data, or other materials
          that you may share with BiMiLeap is free
          from all legal implications, including any
          copyright implications and that such content
          does not in any manner infringe upon rights
          of any other person. You further agree that
          you shall not submit any content that does
          not belong to you, unless you have necessary
          licenses or have obtained permission from
          the rightful owner of the material or you
          are otherwise legally entitled to post such content.
          `
        },
        sectionTwoParagraphFive(){
          return `
           You agree that you shall not use BiMiLeap’s
           platform to upload or communicate any
           information or content that is defamatory
           in character or is otherwise threatening,
           abusive, vulgar, objectionable or illegal in
           any manner. You agree that you shall not distribute
           or post spam, unsolicited or bulk electronic communications.
           You further agree that you shall not distribute viruses or
           other technological programs that may harm BiMiLeap’s
           systems or attempt to circumvent them in any ways.
           You agree that you shall not use BiMiLeap in any
           manner which may intentionally or unintentionally
           violate any applicable laws.
          `
        },
        sectionTwoParagraphSix(){
          return `
          You understand that BiMiLeap may have very
          limited opportunity to monitor or control the
          content and as such cannot guarantee or endorse
          the usefulness, truthfulness, accuracy otherwise
          of the Content that may be posted by its users
          and BiMiLeap does not assume any responsibility
          for such content.
          `
        },
        sectionTwoParagraphSeven(){
          return `
          While we may or may not monitor or endorse that the content
          posted by our users is free from all implications,
          including copyright infringements, we at BiMiLeap will
          respond to your requests to remove any content which may be
          infringing, provided you are able to submit sufficient
          materials to us to demonstrate that such content belongs
          to you, has been copied by another user and has been
          posted at our servers without your authority and consent.
          We however reserve our right to remove or not to remove
          the content alleged to be infringing and our decision in this
          regard shall be final. We may also remove any such content
          which may be infringing suo moto without any prior notice
          and at our sole discretion.
          `
        },
        sectionTwoParagraphEight(){
          return `
          You understand that BiMiLeap has a right to refuse
          any content, which may be submitted by you, to be
          published on our platform, servers and website
          and it is in the sole discretion of BiMiLeap to
          refuse any publication of any content or
          information without assigning any reasons.
          `
        },
        sectionTwoParagraphNine(){
          return `
          You understand that BiMiLeap does not accept unsolicited ideas,
          strategies, marketing tips or suggestions as to technologies
          or otherwise. In order to avoid misunderstandings
          in case where BiMiLeap’s activities bear coincidental
          similarities with one or more of the thousands of
          unsolicited ideas offered to us, you understand that
          such incidental similarity does not give you any right
          to claim any interest in our products or services.
          We therefore do not entertain unsolicited ideas.
          However, should you still choose to send in your
          ideas, you agree and understand that your idea
          will automatically become the property of BiMiLeap,
          without any compensation to you; and we shall have
          no obligation to return your idea to you or respond to you in any way.
          `
        },
        sectionThreeParagraphOne(){
          return `
          BiMiLeap respects your Intellectual Property Rights
          and we expect the same from you.  All images, content
          and other information and materials used on BiMiLeap
          are either proprietary to BiMiLeap or have been
          reproduced with appropriate licenses, permission
          of the copyright owners or are submitted by its
          users or are from free-to-use public domain sources.
          `
        },
        sectionThreeParagraphTwo(){
          return `
          You agree to respect the Intellectual Property Rights of BiMiLeap,
          including but not restricted to the trademark BiMiLeap,
          its designs, logos, artistic representations,
          and patents and/or pending applications of BiMiLeap.
          `
        },
        sectionThreeParagraphThree(){
          return `
          You agree that you shall not use BiMiLeap’s trademarks
          for any products or services in any manner that
          may be likely to create any confusion or deception
          amongst the customers, member of trade and general
          public in any manner. You further agree that you shall
          not use BiMiLeap’s trademarks in any manner which
          may be disparaging or which may dilute the distinctive
          character or otherwise be detrimental to the value of such trademarks.
          `
        },
        sectionThreeParagraphFour(){
          return `
          You agree not to challenge the validity of BiMiLeap’s trademarks,
          copyrights, patents, designs or other any other intellectual
          property and not to take any action which may in
          manner jeopardize BiMiLeap’s rights therein.
          `
        },
        sectionFourParagraphOne(){
          return `
          You understand, that to use BiMiLeap’s Content,
          you may be required to submit the personal information such
          as your name, address, contact details, e-mail address,
          telephone number, etc. All information and/or data that you
          may enter into BiMiLeap, including data sets to conduct survey
          and for research, unless otherwise indicated, may be publically
          visible. Thus, any information you choose not to share must be
          expressly marked as “private” where our system allows you to make such a choice.
          `
        },
        sectionFiveParagraphOne(){
          return `
          Any information submitted by you shall be used only for
          the purpose indicated and no information expressly marked
          as “private” shall be made available to any third parties,
          except where necessary in connection with services
          provided by appropriate intermediaries.
          `
        },
        sectionFiveParagraphTwo(){
          return `
          BiMiLeap may however disclose such personal information
          to third parties solely in order to comply with the
          law or in accordance with the requests made by law enforcement agencies.
          `
        },
        sectionSixParagraphOne(){
          return `
          You agree that the information provided by you may be used by
          BiMiLeap for providing you the Content in the most effective
          manner and for all ancillary purposes including but not limited
          to billing, credit card processing, customer interaction,
          investigation of potential violations, including any fraud,
          security or technical issues
          `
        },
        sectionSevenParagraphOne(){
          return `
          Cookies are small text used by a browser to store information
          on your local drive / disc on your computer or smartphone.
          BiMiLeap may access and set cookies in your system to customize our services,
          provide you with content that is most relevant to you,
          to protect your data amongst others.
          `
        },
        sectionEightParagraphOne(){
          return `
          Your password is your sensitive personal information and
          we shall not disclose your password to anyone. While BiMiLeap
          takes all reasonable measures to protect security and
          integrity of its systems and to protect the Content from any hacking
          or being compromised in any other manner, BiMiLeap does not assume
          responsibility for any hacked passwords. Thus, if you share your password or
          your personal information with others, or your account is hacked,
          you are responsible for all actions taken in the name of your account.
          If you lose control of your password, you may lose substantial
          control over your personal information and may be subject to
          legally binding actions taken on your behalf. Therefore,
          if your password has been compromised for any reason, you
          should immediately notify BiMiLeap and change your password.
          `
        },
        sectionNineParagraphOne(){
          return `
          BiMiLeap implements all necessary technological and security
          measures to prevent any unauthorised access, or misuse of data
          on its servers, in accordance with applicable laws in
          force relative to the protection of personal data.
          `
        },
        sectionNineParagraphTwo(){
          return `
          However, should any personal information/data belonging to you is
          accessed by any unlawful interference or circumvention by a third party,
          beyond the control of BiMiLeap, BiMiLeap does not assume any
          liability with respect to the same.
          `
        },
        sectionTenParagraphOne(){
          return `
          You understand that BiMiLeap may contact you periodically
          to provide any updates service announcements, change in Terms of Service,
          or Content via email address provided. To unsubscribe from such communication,
          you may refer or contact customer support service as provided in the website.
          `
        },
        sectionElevenParagraphOne(){
          return `
          BiMiLeap may request information from its users via web surveys.
          Participation in such surveys is voluntary and the user will have
          an option to opt in or opt out of providing such information.
          `
        },
        sectionTwelveParagraphOne(){
          return `
          BiMiLeap’s website or mobile application may contain links to
          third party web sites not maintained by BiMiLeap and you
          understand that your access to such links is entirely governed
          by privacy policies of such websites / links and not by these Terms of Service.
          `
        },
        sectionThirtheenParagraphOne(){
          return`
          If there are any questions about BiMiLeap’s Terms of Service, please contact BiMiLeap at:
          `
        }

      }
    }
</script>

<style scoped lang="scss">

  .text{
    padding: 5%;
    font-size: 14px;
    line-height: 17px;
  }

  .paragraph{
    padding: 1% 0;
  }

  .section{
    padding: 5% 0;
  }

  .title-number{
    /*padding-right: 5%;*/
  }

  .title{
    text-decoration: underline;
  }

</style>
